<div>
  <h1 mat-dialog-title class="dialog-title">
    <b class="dialog-title-content">{{ 'MEETING_SCHEDULER.BOOKING_URL_DIALOG.TITLE' | translate }}</b>
  </h1>

  <div mat-dialog-content class="dialog-content">
    <p class="dialog-message">
      {{ 'MEETING_SCHEDULER.BOOKING_URL_DIALOG.MESSAGE' | translate }}
    </p>

    <div class="url-container">
      <div class="url-field">
        <input readonly [value]="data.bookingUrl" class="url-input" #urlInput />
        <button
          mat-icon-button
          class="copy-button"
          (click)="onCopyUrl()"
          [class.copied]="copied"
          matTooltip="{{
            copied
              ? ('MEETING_SCHEDULER.BOOKING_URL_DIALOG.COPIED' | translate)
              : ('MEETING_SCHEDULER.BOOKING_URL_DIALOG.COPY' | translate)
          }}"
        >
          <mat-icon>{{ copied ? 'check' : 'content_copy' }}</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <mat-dialog-actions align="end">
    <button mat-flat-button color="primary" (click)="onClose()" cdkFocusInitial>
      {{ 'MEETING_SCHEDULER.BOOKING_URL_DIALOG.CLOSE' | translate }}
    </button>
  </mat-dialog-actions>
</div>
